import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetActuator } from 'src/app/models/actuator/getActuator';
import { GetActuatorType } from 'src/app/models/actuator/getActuatorType';
import { GetActuatorDataType } from 'src/app/models/actuator/getActuatorDataType';

@Injectable({
  providedIn: 'root'
})
export class VisitService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Visit';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetActuator> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetActuator>(`${this.REQUEST_URL}/report`, { params: httpParams });
  }

  getMyVisits(parameters: any): Observable<GetActuator> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetActuator>(`${this.REQUEST_URL}/my-visits`, { params: httpParams });
  }

  getScheduled(parameters: any): Observable<GetActuator> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetActuator>(`${this.REQUEST_URL}/scheduled`, { params: httpParams });
  }

  getRequesteds(parameters: any): Observable<GetActuator> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetActuator>(`${this.REQUEST_URL}/requesteds`, { params: httpParams });
  }

  getListAll(idEnterprise:number): Observable<any> {
    return this.httpClient.get<any>(`${this.REQUEST_URL}/enterprise/`+idEnterprise);
  }

  get(id: any){
    return this.httpClient.get<any>(`${this.REQUEST_URL}/`+id);
  }

  create(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }

  createVisitUser(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}/user`,data);
  }

  createVisitCar(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}/car`,data);
  }

  update(data: any){
    return this.httpClient.put<any>(`${this.REQUEST_URL}`,data);
  }

  approved(data: any){
    return this.httpClient.patch<any>(`${this.REQUEST_URL}/approved`,data);
  }

  rejected(data: any){
    return this.httpClient.patch<any>(`${this.REQUEST_URL}/rejected`,data);
  }

  cancelled(data: any){
    return this.httpClient.patch<any>(`${this.REQUEST_URL}/cancelled`,data);
  }

  delete(id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/` + id);
  }

  deleteVisitUser(idVisit:number,id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/${idVisit}/user/` + id);
  }

  deleteVisitCar(idVisit:number,id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/${idVisit}/car/` + id);
  }

  GetAvailablesTimeByDate(data){
    return this.httpClient.post<any>(`${this.REQUEST_URL}/availables-time`,data);
  }
}
